import Hero from '../../components/Hero'
import './EducationInstitutions.css'

const EducationInstitutions = () => {
  return (
    <>
      <Hero 
        title="Education & Institutions"
        subtitle="Creating safe, clean environments that support learning and growth."
        backgroundImage="/sectors/education/education.png"
        height="55.78125vh"
      />
      
      <section>
        <div className="section-header">
          <h2>Sector Overview</h2>
        </div>
        <p>A well‑maintained educational environment fosters concentration, creativity and wellbeing. Adept Group partners with schools, colleges and universities to deliver customised cleaning programs that nurture students and staff. Our professional teams use safe, environmentally responsible products and proven processes to maintain hygienic spaces without disrupting the learning experience.</p>
        <div className="sector-grid">
          <article>
            <h3>Kindergarten to University</h3>
            <p>Comprehensive cleaning for classrooms, lecture theatres, libraries and common areas across all educational levels.</p>
          </article>
          <article>
            <h3>Sporting Areas &amp; Amenities</h3>
            <p>Specialised cleaning of gyms, sports halls, change rooms and swimming facilities to keep them safe and inviting.</p>
          </article>
          <article>
            <h3>Holiday Deep Cleaning</h3>
            <p>Extensive cleans during term breaks to refresh carpets, flooring and high‑use areas ready for the new semester.</p>
          </article>
          <article>
            <h3>Special Events &amp; Graduations</h3>
            <p>Pre‑ and post‑event cleaning to ensure your campus looks its best for open days, ceremonies and community gatherings.</p>
          </article>
        </div>
      </section>
      
      <section>
        <div className="section-header">
          <h2>Services We Provide</h2>
        </div>
        <ul className="services-list">
          <li>Daily cleaning of classrooms, laboratories and administrative offices</li>
          <li>Carpet steam cleaning and hard floor maintenance</li>
          <li>High‑pressure cleaning and stain removal for outdoor areas</li>
          <li>Window cleaning for internal and external glazing</li>
          <li>Waste removal, recycling and resource‑recovery programs</li>
        </ul>
      </section>
      
      <section className="cta-section">
        <h2>Supporting Learning Environments</h2>
        <p>Partner with us to create clean, inspiring spaces that help students and teachers thrive.</p>
        <a className="cta-button" href="/contact">Enquire Now</a>
      </section>
    </>
  )
}

export default EducationInstitutions
